import { HELP_SUPPORT_FORM_ID, helpFaqItemId } from '@/constants/helpCenter';

export function scrollToHelpSupportForm(behavior: ScrollBehavior = 'smooth'): void {
  document.getElementById(HELP_SUPPORT_FORM_ID)?.scrollIntoView({ behavior, block: 'start' });
}

export function scrollToHelpFaqItem(faqId: string, behavior: ScrollBehavior = 'smooth'): void {
  document.getElementById(helpFaqItemId(faqId))?.scrollIntoView({ behavior, block: 'start' });
}

export function openHelpSupportFromHash(options: {
  onOpenDialog: () => void;
  mobileMaxWidthPx?: number;
}): void {
  if (typeof window === 'undefined') return;
  const hash = window.location.hash.replace(/^#/, '');
  if (hash !== HELP_SUPPORT_FORM_ID) return;

  const isNarrow = window.matchMedia(`(max-width: ${options.mobileMaxWidthPx ?? 1023}px)`).matches;
  if (isNarrow) {
    options.onOpenDialog();
    return;
  }

  scrollToHelpSupportForm();
}
